



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import u from '@/utility/utility';
import { Cart } from '@/models/cart';
import { Product } from '@/models/product';

@Component({
    components: {
        Loading,
    },
})
export default class ListCart extends Vue {
    private eventEmit = {
        eventQuantityChange: 'eventQuantityChange',
        eventFeeShipChange: 'eventFeeShipChange',
        eventFragileGoodsChange: 'eventFragileGoodsChange',
        eventChooseCart: 'eventChooseCart',
        eventChooseProduct: 'eventChooseProduct',
        eventCommentChange: 'eventCommentChange',
        eventChangeDescription: 'eventChangeDescription',
        eventDeleteItem: 'eventDeleteItem',
        eventDeleteCart: 'eventDeleteCart',
    };

    @Prop({default: null})
    private cartItem!: Cart;

    protected proxyImage(src: string): string {
        return u.proxyImage(src);
    }

    private onQuantityChange(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventQuantityChange, emitData);
    }

    private adjustQuantity(productIndex: number, delta: number) {
        const product = this.cartItem.products[productIndex];
        product.quantity = Math.max(1, (Number(product.quantity) || 1) + delta);
        this.onQuantityChange(productIndex);
    }

    private onQuantityKeyDown(e: any) {
        if (e.key === '.' || e.key === '-') {
            e.preventDefault();
        }
    }

    private onChooseCart() {
        const emitData = {
            cartItem: this.cartItem,
        };
        this.$emit(this.eventEmit.eventChooseCart, emitData);
    }

    private onChooseProduct(product: Product) {
        const emitData = {
            cartId: this.cartItem.id,
            product,
        };
        this.$emit(this.eventEmit.eventChooseProduct, emitData);
    }

    private onCommentChange(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventCommentChange, emitData);
    }

    private onDeleteItem(productIndex: number) {
        const emitData = {
            cartItem: this.cartItem,
            productIndex,
        };
        this.cartItem.isLoading = true;
        this.$emit(this.eventEmit.eventDeleteItem, emitData);
    }

    private onDeleteCart() {
        const emitData = {
            cartItem: this.cartItem,
        };
        this.$emit(this.eventEmit.eventDeleteCart, emitData);
    }
}
